"use client";

import Image from "next/image";
import { Icons } from "@/components/icons";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { RichText } from "@graphcms/rich-text-react-renderer";
import Link from "next/link";
import { serializer } from "@/utils/rich-text-renderer";

interface Props {
  columns: any;
}

export default function Columns({ columns }: Props) {
  // TODO: Fix type
  const imageRef = useRef<HTMLImageElement>(null);

  //   useGSAP(() => {
  //     gsap.to(imageRef.current, {
  //       duration: 1,
  //       ease: "power4.inOut",
  //       scrollTrigger: {
  //         trigger: triplet.triplet?.url || "",
  //         start: "top top",
  //         end: "bottom bottom",
  //         scrub: true,
  //       },
  //     });
  //   });

  const renderThis = (columns: any) => {
    return !!(columns.contentColumns || columns.contentStyle);
  };

  const columnStyle = columns.contentStyle != "TwoColumns" ? "ThreeColumns" : "TwoColumns";

  if (renderThis(columns)) {
    switch (columnStyle) {
      case "TwoColumns":
        return (
          <div className="cs-container mb-20 mt-0 md:mb-20 lg:mt-20">
            <div className="grid grid-cols-1 gap-20 sm:gap-10 lg:grid-cols-2 lg:gap-14 xl:gap-20">
              {columns.contentColumns.map((column: any, index: number) => (
                <div key={index} className="relative mr-auto flex min-h-[400px] w-full sm:h-[400px]">
                  <div
                    className="absolute bottom-[38px] left-0 top-[38px] hidden flex-col items-center justify-center bg-[#E5E5E5] pr-4 sm:flex md:left-0"
                    style={{ clipPath: "polygon(135px 0%, 100% 0%, 100% 100%, 0% 100%)" }}
                  >
                    <div className="ml-auto flex h-full flex-col items-center justify-center p-4 text-center sm:w-[calc(100%-150px)] md:mr-10 xl:w-[calc(100%-200px)]">
                      <h3 className="mb-4 text-center" dangerouslySetInnerHTML={{ __html: column.title }}></h3>
                      <RichText content={column.content.raw} renderers={serializer} />
                    </div>
                  </div>
                  <div
                    className="relative bottom-[38px] left-0 top-[38px] flex flex-col items-center justify-center bg-[#E5E5E5] pr-4 sm:hidden md:left-0"
                    style={{ clipPath: "polygon(100% 0, 100% 100%, 0 100%, 0 170px, 69px 0%)" }}
                  >
                    <div className="ml-auto flex h-full w-[calc(100%-25px)] flex-col items-center justify-center p-4 text-center sm:w-[calc(100%-150px)] md:mr-10 lg:w-[calc(100%-200px)]">
                      <h3 className="text-center" dangerouslySetInnerHTML={{ __html: column.title }}></h3>
                      <RichText content={column.content.raw} renderers={serializer} />
                    </div>
                  </div>
                  <Icons.mirrorLine className="absolute -left-[10px] top-7 z-10 h-1/2 w-auto text-primary sm:-left-4 sm:top-0 sm:h-full" />
                </div>
              ))}
            </div>
          </div>
        );
      case "ThreeColumns":
        return (
          <div className="cs-container mb-10">
            <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
              {columns.contentColumns.map((column: any, index: number) => (
                <div key={index} className="flex flex-col">
                  <div className={`relative mb-10 flex h-[285px] flex-col ${columnStyle}`}>
                    <div
                      className="absolute bottom-[15px] left-2 right-0 top-[85px] flex flex-col items-center justify-center bg-[#E5E5E5] pr-4"
                      style={{ clipPath: "polygon(78px 0%, 100% 0%, 100% 100%, 0% 100%)" }}
                    >
                      <h3 className="ml-20 text-center" dangerouslySetInnerHTML={{ __html: column.title }}></h3>
                    </div>
                    {column.icon.url && (
                      <Image
                        className="absolute -bottom-2 right-8 h-[50px] w-auto max-w-[50px]"
                        src={column.icon?.url || ""}
                        alt={column.icon?.altText || ""}
                        width={400}
                        height={400}
                      />
                    )}
                    <Icons.mirrorLine className="absolute left-0 top-0 z-10 h-full w-auto text-primary" />
                    <div
                      className="absolute top-[15px] w-full max-w-[113px] scale-x-[-1]"
                      style={{ clipPath: "polygon(0px 0%, 100% 0%, 100% 100%, 73px 100%)" }}
                    >
                      <Image
                        src={column.image?.url || ""}
                        alt={column.image?.altText || ""}
                        priority
                        width={1920}
                        height={1080}
                        className="!h-[175px] !w-[-webkit-fill-available] scale-x-[-1] bg-white object-cover object-[center_10%]"
                      />
                    </div>
                  </div>
                  <div className="px-4 text-center">
                    <RichText content={column.content.raw} renderers={serializer} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
    }
  }
}
